import { Input } from '@angular/core';
import { ComponentFactoryResolver } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CustomComponent } from 'src/app/core/view/component/custom/custom-component.interface';
import { OrganizationsService } from '../../organizations.service';

@Component({
  selector: 'app-tasks-widget',
  templateUrl: './tasks-widget.component.html',
  styleUrls: ['./tasks-widget.component.scss']
})
export class TasksWidgetComponent implements OnInit,CustomComponent {
  @Input() public data: any;

  public ret: any = {};
  private id:number = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private organizationService: OrganizationsService,
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.loadStatsActivities(this.id);
    });
  }
  loadStatsActivities(id){
    this.organizationService.statsActivities(id).subscribe(
      data=>{
        this.ret = data;
      },
      error=>{
        //TODO: messageService aquí.
      }
    );
  }

  onEvent(component:string, event:string){
    //console.log(component, event);
    if(event=="reload"){
      this.loadStatsActivities(this.id);
      //console.log("taskWidget reload.")
    }
  }
}
